import Countries from '../dynamics/countries'

export const getCountryById = (countryId) => Countries.find(({ id }) => id === countryId)